/**
 * AUTO-GENERATED AT BUILD TIME - DO NOT EDIT.
 *
 * Source: https://cc-fe-bifrost.prod-east.frontend.public.atl-paas.net/bifrost-static/assets/master/preload-query-batch-config.json
 */
// prettier-ignore
export const Q: readonly string[] = [
	"AIPlannerSyncBylineQuery",
	"ApprovalsContextApprovalsDataQuery",
	"ArchivedPageBannerV2ArchivedPageBannerContainerQuery",
	"ArchivedPageBannerV2ArchivedPageBannerQuery",
	"AudienceSegmentationContextProviderQuery",
	"BlogTreeRootComponentQuery",
	"ByLineForgeAppGeneralContentPropertyQuery",
	"CollabDraftQuery",
	"ContentBlogUnifiedQuery",
	"ContentHeaderPresenceContentSettingsQuery",
	"ContentHeaderUnifiedQuery",
	"ContentPrerequisitesQuery",
	"ContentRedirectQuery",
	"ContentTypesHeaderQuery",
	"ContentUnifiedQuery",
	"CookieConsentPreferences",
	"CoverPictureQuery",
	"CustomHeaderFooterQuery",
	"DatabaseContainerQuery",
	"EditContentButtonQuery",
	"EditorContentStateQuery",
	"EditorPreferencesQuery",
	"EmojiTitleQuery",
	"EndOfPageRecommendationQuery",
	"FollowingFeedWithSortByStorageSnippetsQuery",
	"FooterCreateButtonsQuery",
	"ForgeExtensionList",
	"GlobalNavigationComponentQuery",
	"GrantAccessDialogLoaderQuery",
	"HomeRecentWorkQuery",
	"InlineCommentsFocusedInlineCommentQuery",
	"InvitedAppShortcutsRecommendationsQuery",
	"IsSuperAdminQuery",
	"LegacyMacroRendererQueryBodyQuery",
	"LivePagesByLineLastUpdatedQuery",
	"LocalStorageQuery",
	"NativeCollabQuery",
	"NotFoundContainerQuery",
	"NotificationsButtonQuery",
	"ObjectCommentContainerPreloadObjectCommentsQuery",
	"PageOwnershipByLineWithCollaboratorsDropdownContentQuery",
	"PageRestrictionsContextQuery",
	"PageTreeMacroAncestorsQuery",
	"PageTreeMacroChildrenQuery",
	"PageTreeMacroSearchByTitleQuery",
	"PageTreeMacroSpaceHomepageQuery",
	"PageTreeQuery",
	"PageTreeQueryWithSpaceKeyQuery",
	"PermissionCheckAddCommentQuery",
	"PersistentInviteEligibleQuery",
	"PersonalizedTemplatesV2AllTemplatesQuery",
	"PopularFeedWithTimeGranularityStorageSnippetsV2Query",
	"ReactionsContentQuery",
	"RecentlyUpdatedMacroQuery",
	"RendererContentStateQuery",
	"RestrictedPageWithCanViewQuery",
	"ScreenQuery",
	"SiteInformationQuery",
	"SmartCreateFeedbackBannerQuery",
	"SmartCreatePageEditorDataWrapperComponentQuery",
	"SpaceNavigationQuery",
	"SpaceOverviewIdQuery",
	"SpaceOverviewQuery",
	"SpaceQuery",
	"SpaceRestrictionCheckQuery",
	"ThemeQuery",
	"TopNavigationQuery",
	"UserSettingsQuery",
	"ViewSpaceExternalCollaboratorsDialogQuery",
	"WebItemLocationQuery_page.metadata.banner",
	"WebItemLocationQuery_system.content.byline",
	"WebItemLocationQuery_system.header_left",
	"WebItemLocationQuery_system.user",
	"WebPanelLocationQuery_atl.footer",
	"WebPanelLocationQuery_atl.general",
	"WebPanelLocationQuery_atl.general_atl.footer",
	"WebPanelLocationQuery_atl.page.content.footer.actions",
	"WelcomeMessagesQuery",
	"WhiteboardUnifiedQuery",
	"contentAppearanceQuery",
	"contentSmartLinksORS",
	"fetchMentionsProviderDataQuery",
	"graphqlHelpersDSPIsActionEnabledForContentQuery",
	"graphqlHelpersFetchMediaTokenQuery",
	"graphqlHelpersFetchMediaTokenWithMediaItemsQuery",
	"loomUserPermissionQuery",
	"multiMacroQueryWithAppKeyQuery",
	"onboardingStateGetOnboardingStateQuery",
	"onboardingStateGetOnboardingStateQuery_aifc-onboarding_hasSeenAIFCSpotlight_8",
	"onboardingStateGetOnboardingStateQuery_auto-page-emoji_emojiTitleDiscovered",
	"onboardingStateGetOnboardingStateQuery_create-with-rovo-announcement-splash_hasSeenSplashModal",
	"onboardingStateGetOnboardingStateQuery_creation-focused-nav_shouldShowSpotlight_2",
	"onboardingStateGetOnboardingStateQuery_cross-join-nth-user-onboarding_trendingPages_2",
	"onboardingStateGetOnboardingStateQuery_editor-state_editorOnboardingEligiblity_12",
	"onboardingStateGetOnboardingStateQuery_land-users-in-editor-with-revamped-bpqa_revampedBpqaShownAt",
	"onboardingStateGetOnboardingStateQuery_onboarding-intent-experiences_onboardingIntentExperienceClosed_18",
	"onboardingStateGetOnboardingStateQuery_onboarding-origin-state_attributes_65",
	"onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin_10",
	"onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin_5",
	"onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin_6",
	"onboardingStateGetOnboardingStateQuery_onboarding-state_nthUserOnboardingCompletedTimestamp",
	"onboardingStateGetOnboardingStateQuery_storage-enforcement-state_flagsDismissedFreeThreshold_165",
	"pageButtons",
	"preloadAutohighlightsQuery",
	"preloadContentSmartLinksViewPageExtensionsAndRendererAssetsQuery",
	"preloadCreateSpaceQuery",
	"preloadEditorNodeDataProvidersDataQuery",
	"preloadForgeApps_FetchPreFilteredForgeAppsQuery",
	"preloadLegacyBridgeQuery",
	"preloadOperationsQuery",
	"preloadOutgoingLinksQuery",
	"preloadPageStatusQueryDataQuery",
	"preloadPendingRequestExistsQuery",
	"preloadPersonalSpaceDetailsQuery",
	"preloadRovoChatIdentityQuery",
	"preloadShareAndRestrictButtonQuerySpaceOverviewQuery",
	"preloadTemplatesCollectionEligibleQuery",
	"searchCombinedConfig",
	"searchResults",
	"shortcutsSmartLinksQuery",
	"sidenavSmartLinksORS",
	"useAccessRequestSettingsQuery",
	"useAnalyticsByLineQuery",
	"useAttachmentsMacroDataQuery",
	"useAudioContentQuery",
	"useBlogPostsQueryQuery",
	"useChangeHistoryDataQuery",
	"useConnectorOnboardingStateQuery",
	"useConnectorOnboardingTeamTypeQuery",
	"useConnectorStatesQuery",
	"useContentByLabelDataQuery",
	"useContentClassificationContentDataClassificationQuery",
	"useContentClassificationV2ContentDataClassificationQuery",
	"useContributorsDataQuery",
	"useDetailsSummaryADFQueryQuery",
	"useDynamicSplitButtonCatchupLastViewedTimeQuery",
	"useEditorContentModeValueQuery",
	"useEmojiEverSetPropertyQuery",
	"useFabricEligibilityMigrationQuery",
	"useFeatureDiscoveryFeatureDiscoveryQuery",
	"useFeedTypeSelectorRefreshQuery",
	"useGetCurrentStorageUsageQuery",
	"useGetTeamAndSubanchorGetPersonalSpaceKeyQuery",
	"useGetTeamAndSubanchorGetSubanchorsAGGQuery",
	"useHomeWidgetStateQuery",
	"useIsEligibleForNthUserHomeOnboardingLicensedUserCountQuery",
	"useIsLoomEntryPointsEnabledQuery",
	"useIsUserViewingSpaceAsAnonQuery",
	"useLicensedProductsQueryForGlobalAppShortcutsQuery",
	"useLoomTenantProvisionStatusQuery",
	"usePageIncludeMacroQueryByIdQuery",
	"usePageIncludeMacroQueryByTitleQuery",
	"usePageTreeSearchQueryQuery",
	"usePopularFeedWithTimeGranularityStorageQuery",
	"usePopularLabelsDataQuery",
	"usePopularLabelsDataSpaceIdQuery",
	"usePreloadCommentButtonQuery",
	"useProfileInfoUserContextQuery",
	"useReadTimeQuery",
	"useRegisterAdminAnnouncementBannerQuery",
	"useShareAndRestrictButtonDataQuery",
	"useSpaceBaseQueryBaseQuery",
	"useSpaceDetailQuery",
	"useSpaceEnabledContentTypesQuery",
	"useSpaceViewsDataSpaceRootQuery",
	"useSpaceViewsOptionsPersistenceQuery",
	"useSpacesDataAnonymousSpacesQuery",
	"useSpacesDataMyVisitedSpacesQuery",
	"useSpacesDataStarredSpacesQuery",
	"useTitleContentPropertiesForEditorQuery",
	"useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery",
	"useTitleContentPropertiesForPublishedPageQuery",
	"useUserByLicensedProductsQuery",
	"useViewPdfDataQuery",
	"useViewXlsDataQuery",
	"viewPresenceBootstrapQuery"
];

// prettier-ignore
export const R: Readonly<Record<string, string>> = {
	"prod-apne": "6e2f7b8a7cced7ffffd6eeffffffdb1280dfbde13f5f",
	"prod-apne2": "7e3f7b9a7cced5efffd6eeffffffdb1290ffbdf43f1f",
	"prod-apse": "6e2d7b9a7cced4efffd6ef7f7ffddb1200ffb9e17f5e",
	"prod-apse2": "6eaf7b9e7cced4effff7effffeffdb1280fbb9a5ff57",
	"prod-apsouth": "666ffb8e7cced5effff6efffffffdb5680ffb9c0bf1f",
	"prod-cacentral": "6eef7bcafcded7ffffd7ef7fffffdb5290efbef4bf1f",
	"prod-east": "7ebf7f9a7deed7fffff7eeffffffdbd293ffbff57f7e",
	"prod-eucentral": "7eff7f9a7d2ed5efffd7eeffffffdbd281fbf9a9ff7f",
	"prod-eucentral2": "4eaf738a78ced4efffd6aeffffff9b0280fbb9a43f17",
	"prod-euwest": "7ebf7f9a7ceed6fbffffeeff5effdb1280fbfba9f77f",
	"prod-euwest2": "6aaf738a7cced7fffff7eeffff7fdbd280ffbbe4b71f",
	"prod-west2": "6eaf7b9a7cced7fffff6eeffffffdb1280ffbfe57f5f",
	"stg-east": "a5e7fb8bdcc3d777dfb6fefffeff961298df3fd2bf9d"
};

export const generatedAt: string | null = "2026-10-21T03:16:43.425Z";

export const sourceUrl: string | null = "https://cc-fe-bifrost.prod-east.frontend.public.atl-paas.net/bifrost-static/assets/master/preload-query-batch-config.json";
